// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require.context('../images', true, /\.(gif|jpg|png|svg|webp)$/i)
require.context('../fonts', true, /\.(ttf|woff|woff2|svg)$/i)

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

import "@stylesheets/site.scss";
//import "babel-polyfill";

import header from '@script/blocks/header';
import modal from '@script/blocks/modal';
import mainEvent from '@script/blocks/main-event';
import mainBanner from '@script/blocks/main-banner';
import ticker from '@script/blocks/ticker';
import specialEvent from '@script/blocks/special-event';
import profile from '@script/blocks/profile';
import scrollto from '@script/blocks/scrollto';
import repertoire from '@script/blocks/repertoire';
import onscrollAnimation from '@script/blocks/onscroll-animation';
import filter from '@script/blocks/filter';
import calendar from '@script/blocks/calendar';
import poster from '@script/blocks/poster';
import search from '@script/blocks/search';
import news from '@script/blocks/news';
import posterItem from '@script/blocks/poster-item';
import contacts from '@script/blocks/contacts';
import ticketDate from '@script/blocks/ticket-date';
// import ticketTip from '@script/blocks/ticket-tip';
import cookiePane from '@script/blocks/cookie-pane';
import department from '@script/blocks/department';

import '@script/blocks/map';

import '@script/avilkin/blind';
import '@script/avilkin/avilkin';
import '@script/avilkin/sendsaysubscribe';
import '@script/avilkin/carrotquest';
import '@script/avilkin/dashamail';
import avpopup from '@script/avilkin/avpopup';
import avpopupcont from '@script/avilkin/avpopupcont';
import avvcircular from '@script/avilkin/avvcircular';

const application = Application.start();
const context = require.context("@script/controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

header();
search();
modal();
mainEvent();
mainBanner();
ticker();
specialEvent();
profile();
scrollto();
repertoire();
onscrollAnimation();
filter();
calendar();
poster();
news();
posterItem();
contacts();
ticketDate();
// ticketTip();
cookiePane();
department();
avpopup();
avpopupcont();
avvcircular();


// import * as Trix from "trix";

// Trix.config.textAttributes.sovrwide = {
//   tagName: 'span',
//   className: "sovr-wide",
//   inheritable: true
// }

// window.trixConfig = Trix.config;
// // console.log('Trix.config', Trix.config);
// // console.log(Trix.config.toolbar.getDefaultHTML());


// // var Trix  = require("trix")
// // Trix.config.blockAttributes.heading7 = {
// //   tagName: "h6", // Trix only supports h1-h6 directly, so we use h6 and style it later
// //   className: "trix-h7", // Custom class for styling
// //   inheritable: true
// // };

// // Ensure Trix is globally available if needed for other scripts


// Trix.config.toolbar.getDefaultHTML = () => {return `
//     <div class="trix-button-row">
//     <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
//       <button type="button" class="trix-button trix-button--icon trix-button--icon-bold trix-active" data-trix-attribute="bold" data-trix-key="b" title="bold" tabindex="-1" data-trix-active="">Bold</button>
//       <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="italic" tabindex="-1">Italic</button>
//       <button type="button" class="trix-button trix-button--icon trix-button--icon-link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="link" tabindex="-1">Link</button>
//       <button type="button" class="trix-button  " data-trix-attribute="sovrwide" title="шрифт Sovremennik" tabindex="-1">SV</button>
//         </span>
//       <span class="trix-button-group trix-button-group--block-tools" data-trix-button-group="block-tools">
//         <button type="button" class="trix-button" data-trix-attribute="heading3" title="H3" tabindex="-1">H3</button>
//         <button type="button" class="trix-button" data-trix-attribute="heading4" title="H4" tabindex="-1">H4</button>

//         <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="List" tabindex="-1">List</button>
//         <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="Ordered list" tabindex="-1">Ordered List</button>
//       </span>
//     <span class="trix-button-group trix-button-group--history-tools" data-trix-button-group="history-tools">
//       <button type="button" class="trix-button trix-button--icon trix-button--icon-undo" data-trix-action="undo" data-trix-key="z" title="Undo" tabindex="-1" disabled="">Undo</button>
//       <button type="button" class="trix-button trix-button--icon trix-button--icon-redo" data-trix-action="redo" data-trix-key="shift+z" title="Redo" tabindex="-1" disabled="">Redo</button>
//     </span>
//   </div>
// `};

// console.log(Trix.config.toolbar.getDefaultHTML());



// document.addEventListener("trix-initialize", function(event) {
//   const editor = event.target;
//   const toolbar = editor.toolbarElement;

//   // Create the H7 button HTML
//   const h7ButtonHTML = `
//     <button type="button" class="trix-button  " data-trix-attribute="sovrwide" title="шрифт Sovremennik" tabindex="-1">SV</button>
//   `;

//   // Find the block tools group and insert the button
//   const blockToolsGroup = toolbar.querySelector(".trix-button-group--block-tools");
//   if (blockToolsGroup) {
//     blockToolsGroup.insertAdjacentHTML("beforeend", h7ButtonHTML);
//   }
// });